import React from 'react';
import NewsFeedsTable from '../components/NewsFeedsTable';

export function NewsFeeds() {
  return <NewsFeedsTable />;
}
